module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.ade4a3b7.svg";